import { useLang } from "../context/LangProvider";
import { useWords,useTitle } from "../hooks";
import { HomeTitle } from "../components";
import { FaMapMarkerAlt, FaLinkedin, FaEnvelope } from "react-icons/fa";
import TrackVisibility from "react-on-screen";
import HTMLReactParser from "html-react-parser";
import styles from "./about.module.css";

const About = () => {
  const [lang] = useLang();
  const langWords = useWords(lang);
  useTitle(langWords.about || "");

  return (
    <div className="text-primary container" style={{ marginTop: "120px" }}>
      <HomeTitle title={langWords.whoAreWe} center />
      <section className="mt-20 p-2 bg-third mx-auto max-w-4xl rounded">
        <iframe
          height="500px"
          className="w-full object-cover"
          src="https://www.youtube.com/embed/xPsENBCKtig"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          frameBorder="0"
        ></iframe>
      </section>
      <section className="flex  mx-auto max-w-4xl mt-10">
        <div
          className={`${styles.about} opacity-80 text-justify p-4`}
        >
          {HTMLReactParser(langWords.aboutUsParagraph ?? "")}
        </div>
        <img className="w-52 h-52 ml-4 hidden md:block" src="./assets/illustrations/about.svg" alt="personal information" />
      </section>
      <section className="mt-10">
        <HomeTitle title={langWords.ourLeaders} center />
        <div className="mt-12 grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 place-items-center">
          {langWords?.leaders?.map((leader, id) => (
            <TrackVisibility key={id} once>
              {({ isVisible }) => (
                <article className="text-center bg-gray-50 rounded py-4 border-b-4 border-primary shadow text-primary max-w-xs">
                  <div className="transform -translate-x-4">
                    <img
                      src={leader.profileImage}
                      className={`w-full h-60 rounded shadow transition ${
                        isVisible
                          ? "opacity-100 animate-animated animate-backInLeft"
                          : "opacity-0"
                      }`}
                      alt="leader"
                    />
                  </div>
                  <div className="my-2">
                    <h3 className="font-bold mb-2 text-xl">{leader.name}</h3>
                    <p> {leader.jobDescription} </p>
                  </div>
                  <footer className="p-2">
                    <ul className="flex items-center justify-center space-x-3">
                      <li>
                        <a
                          href={leader.linkedin}
                          target="_blank"
                          rel="noreferrer noopener"
                          className="flex items-center space-x-1"
                        >
                          <FaLinkedin color="#0A66C2" />
                          <span>Linkedin</span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={`mailto:${leader.email}`}
                          target="_blank"
                          rel="noreferrer noopener"
                          className="flex items-center space-x-1"
                        >
                          <FaEnvelope color="#E4405F" />
                          <span>email</span>
                        </a>
                      </li>
                    </ul>
                  </footer>
                </article>
              )}
            </TrackVisibility>
          ))}
        </div>
      </section>
      <section className="mt-10 mx-auto max-w-4xl ">
        <HomeTitle title={langWords.whereToFindUs} center />
        <address className="opacity-75 text-center">
          <FaMapMarkerAlt className="m-auto mb-2" />
          Cité zerhouni mokhtar, villa 243, RN 24, Mohammadia 16058
        </address>
      </section>
    </div>
  );
};

export default About;
